import { createPortal } from "@design-system/utils/portals";

export const unlockCodePortal = createPortal<{
  lessons?: any[];
  offers?: any[];
}>("unlock-code-portal"); 